import { X } from "lucide-react";
import React, { useEffect, useState } from "react";
import formatDate from "../../common/Formatdate";
import toast from "react-hot-toast";
import moment from "moment";

const AgentassignDialog = ({
  setAgentAssignDialog,
  agentAssignDialog,
  selectedInquiries,
  getAllBookings,
  setSelected,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [usersList, setUsersList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedAgent, setSelectedAgent] = useState(null);
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [loading, setLoading] = useState(false);
  const [finishedResponse, setFinishedResponse] = useState([]);

  const getUsersList = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=100&isSalesAgent=true`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setUsersList(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  useEffect(() => {
    getUsersList();
  }, []);

  const getAssignAgentList = async (type, inquiry) => {
    let payload;

    if (type === "me") {
      payload = {
        bookingId: inquiry?.id,
        agentId: profile && profile?.id,
        agentName: profile && profile?.name,
        agentEmail: profile && profile?.email,
        assginedBy: profile && profile?.id,
      };
    } else {
      payload = {
        bookingId: inquiry?.id,
        agentId: selectedAgent?.id,
        agentName: selectedAgent?.name,
        agentEmail: selectedAgent?.email,
        assginedBy: profile?.id,
      };
    }
    // console.log("Payload for agent assignment history:", payload);
    // setLoading(false);
    // return;
    try {
      const response = await fetch(
        `${apiUrl}/api/salesagentassingedhistories`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(payload),
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setFinishedResponse((prev) => [...prev, data?.dataValues?.bookingId]);
        setLoading(false);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  const handleAssign = async (type, inquiry) => {
    let payload;

    if (type === "me") {
      payload = {
        id: inquiry?.id,
        assignedAgent: profile && profile?.id,
        isSalesAgentAssigned: true,
        inquiryAssignedOn: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
    } else {
      payload = {
        id: inquiry?.id,
        assignedAgent: selectedAgent?.id,
        isSalesAgentAssigned: true,
        inquiryAssignedOn: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      };
    }

    // console.log("Payload for assigning agent to booking:", payload);
    // await getAssignAgentList(type, inquiry);
    setLoading(true);
    try {
      const response = await fetch(`${apiUrl}/api/vehiclebookings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        await getAssignAgentList(type, inquiry);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  const submitAssignAgent = async (type) => {
    await Promise.all(
      selectedInquiries.map((inquiry) => handleAssign(type, inquiry)),
    );
    await getAllBookings();
    toast.success("Agent assigned successfully");
    setSelected([]);
    setAgentAssignDialog(false);
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-start justify-center z-50 pt-10">
      <div className="bg-white w-full max-w-4xl rounded-xl shadow-xl p-6 mt-44">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Assign Agent to Inquiries</h3>
          <button onClick={() => setAgentAssignDialog(false)}>
            <X className="text-slate-500 hover:text-red-500" />
          </button>
        </div>

        <div className="space-y-4">
          <select
            className="w-full rounded-md bg-gray-50 border border-gray-200 px-3 py-2 text-sm text-gray-800 focus:bg-white focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
            //   value={form.documenttype}
            onChange={(e) => {
              const selectedId = e.target.value;
              const selectedUser = usersList.find(
                (user) => String(user.id) === selectedId,
              );
              if (selectedUser) {
                setSelectedAgent({
                  id: selectedUser.id,
                  name: selectedUser.name,
                  email: selectedUser.email,
                  mobile: selectedUser?.mobile,
                });
              }
            }}
          >
            <option value="">Select Sales Agent</option>
            {usersList?.map((item, index) => (
              <option key={index} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>

        <div className="border rounded-lg overflow-hidden mt-4">
          <div className="max-h-44 overflow-y-auto">
            <table className="w-full">
              <thead className="bg-slate-50 border-b sticky top-0 z-10">
                <tr>
                  {[
                    "Inquiry Id",
                    "Source",
                    "Start Date",
                    "End Date",
                    "City",
                    "Created At",
                    "Amount",
                  ].map((h, i) => (
                    <th
                      key={i}
                      className="text-left py-3 px-4 text-xs font-semibold uppercase text-slate-500 bg-slate-50"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {selectedInquiries.length === 0 ? (
                  <tr>
                    <td
                      colSpan={7}
                      className="text-center py-6 text-sm text-slate-500"
                    >
                      No inquiries selected
                    </td>
                  </tr>
                ) : (
                  selectedInquiries.map((item, idx) => (
                    <tr
                      key={idx}
                      className={`border-b hover:bg-teal-50 transition text-sm ${finishedResponse.filter((id) => id === item?.id).length > 0 ? "bg-green-100" : ""}`}
                    >
                      <td className="py-3 px-4">{item?.inquiryID}</td>
                      <td className="py-3 px-4">{item?.source}</td>
                      <td className="py-3 px-4">
                        {formatDate(item?.startDate)}
                      </td>
                      <td className="py-3 px-4">{formatDate(item?.endDate)}</td>
                      <td className="py-3 px-4">{item?.city}</td>
                      <td className="py-3 px-4">
                        {formatDate(item?.createdAt)}
                      </td>
                      <td className="py-3 px-4">{item?.amount}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={() => {
              if (selectedAgent) {
                submitAssignAgent("other");
              } else {
                alert("Please select an agent to assign.");
              }
            }}
            disabled={loading}
            className={`px-5 py-2 rounded-lg text-sm text-white 
      ${
        loading
          ? "bg-teal-400 cursor-not-allowed opacity-60"
          : "bg-teal-600 hover:bg-teal-700"
      }`}
          >
            {loading ? "Assigning..." : "Assign Agent"}
          </button>

          <button
            onClick={() => {
              submitAssignAgent("me");
            }}
            disabled={loading}
            className={`px-5 py-2 rounded-lg text-sm text-white 
      ${
        loading
          ? "bg-blue-400 cursor-not-allowed opacity-60"
          : "bg-blue-600 hover:bg-blue-700"
      }`}
          >
            {loading ? "Assigning..." : "Assign to Me"}
          </button>

          <button
            onClick={() => setAgentAssignDialog(false)}
            disabled={loading}
            className={`px-4 py-2 border rounded-lg text-sm 
      ${loading ? "cursor-not-allowed opacity-50" : "hover:bg-gray-100"}`}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentassignDialog;
